import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHUkBodyLocations from "./Components/BodyUkLocations";

class CHUkLocations extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHUkBodyLocations />
        <Footer />
      </>
    );
  }
}

export default CHUkLocations;
